import {createSlice} from '@reduxjs/toolkit';

const initialState = {
   showAlert: false,
   title: 'Alert!',
   message: '',
   callbackType: '',
   pressOk: false,
};

const ResponseAlertSlice = createSlice({
   name: 'responseAlert',
   initialState,
   reducers: {
      setResponseAlertData: (state, action) => {
         state.showAlert = action.payload.showAlert;
         state.title = action.payload.title;
         state.message = action.payload.message;
         state.callbackType = action.payload.callbackType;
         state.pressOk = false;
      },
      setPressOk: state => {
         state.pressOk = true;
      },
      clearResponseAlertData: state => {
         state.showAlert = false;
         state.title = 'Alert!';
         state.message = '';
         state.callbackType = '';
         state.pressOk = false;
      },
   },
});

export const {setResponseAlertData, setPressOk, clearResponseAlertData} =
   ResponseAlertSlice.actions;
export const getResponseAlertData = state => state.responseAlert;

export default ResponseAlertSlice.reducer;
